import React from "react";
import { apiGet, apiPost } from "../api";

export const LoggedInUserContext = React.createContext([]);

const UnnamedComponent = (props) => {
  const [signedIn, setSignedIn] = React.useState(false);
  const [currentUser, setCurrentUser] = React.useState();
  const refreshUser = React.useCallback(async () => {
    const { parsedResponse } = await apiGet("/api/v1/users/logged_in");
    if (parsedResponse.user) {
      setCurrentUser(parsedResponse.user);
      setSignedIn(true);
    } else {
      setCurrentUser(null);
      setSignedIn(false);
    }
  });
  const performLogout = React.useCallback(async () => {
    await apiPost("/api/v1/auth/logout");
    setCurrentUser(null);
    setSignedIn(false);
  }, [setCurrentUser, setSignedIn]);
  // const performLogin = React.useCallback(async () => {
  // const { parsedResponse, statusCode } = await apiPost("/api/v1/auth/login");
  // if(statusCode === 200){
  // setCurrentUser(parsedResponse.user);
  // setSignedIn(true);
  // } else {
  // setCurrentUser(null);
  // setSignedIn(false);
  // }
  // }, [setCurrentUser, setSignedIn]);
  React.useEffect(() => {
    refreshUser();
    const t = setInterval(() => {
      refreshUser();
    }, 1000 * 60); // 1 minute
    return () => {
      clearInterval(t);
    };
  }, []);

  const passed = React.useMemo(
    () => ({ signedIn, currentUser, performLogout }),
    [signedIn, currentUser, performLogout],
  );
  return (
    <LoggedInUserContext value={passed}>{props.children}</LoggedInUserContext>
  );
};
export default UnnamedComponent;
